import { useLang } from "@/lib/LanguageContext";

export default function Testimonials() {
    const { t } = useLang();
    return (
        <section
            data-testid="testimonials-section"
            className="py-20 lg:py-32 border-y border-hairline bg-ivory-deep/30"
        >
            <div className="mx-auto max-w-screen-2xl px-6 md:px-12 lg:px-20">
                <p className="overline text-terracotta mb-12">
                    {t.testimonials.eyebrow}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
                    {t.testimonials.items.map((q, idx) => (
                        <figure
                            key={q.attr}
                            data-testid={`testimonial-${idx}`}
                            className="flex flex-col"
                        >
                            <span className="font-serif text-6xl leading-none text-terracotta mb-4">
                                “
                            </span>
                            <blockquote className="font-serif italic text-xl md:text-2xl leading-snug text-navy">
                                {q.quote}
                            </blockquote>
                            <figcaption className="overline text-navy/55 mt-6">
                                {q.attr}
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
